import React, { Component, useEffect, useState } from "react";
import Moment from "react-moment";
import moment from "moment";
import AddEditNotes from "../components/OMCRegistry/AddEditNotes";
import { useDispatch, useSelector } from "react-redux";
import { addFormLibrary, getAppFormLibrary, getAppFormLibraryLoading, getLibraryFormAddedStatus, loadAppLibraryForms } from "../app/store/forms";
import { deleteDocument, getDocumentDeleteStatus, getDocuments, getDocumentsLoading, getLocalDocUploadStatus, loadDocuments } from "../app/store/documents";
import { getFieldData } from "../services/appService";
import useDocDownload from "../app/hooks/useDocDownload";
import ViewFormModal from "./ViewFormModal";
import { getSubcontractorById, getSubsCurrentWfTask, loadSubcontractorById } from "../app/store/subcontractor";
import { getRecCurrentWfTask, getRecruiterById, loadRecruiterById } from "../app/store/recruiter";
import { getAlert, getConfirmAlert } from "../services/appAlerts";
import CandidateReqDoc from "../components/OMCRegistry/CandidateReqDoc";
import { getCandidateById, loadCandidateById } from "../app/store/candidate";
import { OverlayTrigger, Popover } from "react-bootstrap";

const AchInformation = (props) => {
  const { workflowTask, item, app, setViewBprmFormShowHide, viewType, achType, setSelectedApp, onBack, hideHeader } = props;

  const [formsLib, setFormsLib] = useState([]);
  const [appDocuments, setAppDocuments] = useState([]);
  const [selectedForm, setSelectedForm] = useState(null);
  const [achFormShowHide, setAchFormShowHide] = useState(false);
  const [noteShowHide, setNoteShowHide] = useState(false);
  const [partnerCurrentWfTask, setPartnerCurrentWfTask] = useState(null);
  const [achCheckCount, setAchCheckCount] = useState(0);
  const [partnerAppData, setPartnerAppData] = useState(null);
  const [docShowHide, setDocShowHide] = useState(false);
  const [uploadType, setUploadType] = useState("");
  const [revealedDetails, setRevealedDetails] = useState({});

  const appFormLibrarySelector = useSelector(getAppFormLibrary);
  const documentsSelector = useSelector(getDocuments);
  const isFormsLoading = useSelector(getAppFormLibraryLoading);
  const isDocsLoading = useSelector(getDocumentsLoading);
  const isLoading = isFormsLoading || isDocsLoading;
  const subsCurrentWfTaskSelector = useSelector(getSubsCurrentWfTask);
  const recCurrentWfTaskSelector = useSelector(getRecCurrentWfTask);
  const libraryFormAddedStatusSelector = useSelector(getLibraryFormAddedStatus);
  const documentDeleteStatusSelector = useSelector(getDocumentDeleteStatus);
  const statusLocalDoc = useSelector(getLocalDocUploadStatus);
  const recruiterByIdSelector = useSelector(getRecruiterById);
  const subcontractorByIdSelector = useSelector(getSubcontractorById);
  const candidateByIdSelector = useSelector(getCandidateById);

  const [handleDownloadFile] = useDocDownload();

  const dispatch = useDispatch();

  useEffect(() => {
    if (workflowTask?.ciid && (viewType !== "candidateList" || achType === "Candidate")) {
      dispatch(loadAppLibraryForms(workflowTask.ciid));
      dispatch(loadDocuments(workflowTask.ciid));
      setAchCheckCount(1);
    }
  }, [workflowTask, achType]);

  useEffect(() => {
    if (subsCurrentWfTaskSelector) {
      dispatch(loadAppLibraryForms(subsCurrentWfTaskSelector.ciid));
      dispatch(loadDocuments(subsCurrentWfTaskSelector.ciid));
      setPartnerCurrentWfTask(subsCurrentWfTaskSelector);
      setPartnerAppData(subsCurrentWfTaskSelector.appData);
      setAchCheckCount(1);
    }
  }, [subsCurrentWfTaskSelector]);

  useEffect(() => {
    if (recCurrentWfTaskSelector) {
      dispatch(loadAppLibraryForms(recCurrentWfTaskSelector.ciid));
      dispatch(loadDocuments(recCurrentWfTaskSelector.ciid));
      setPartnerCurrentWfTask(recCurrentWfTaskSelector);
      setPartnerAppData(recCurrentWfTaskSelector.appData);
      setAchCheckCount(1);
    }
  }, [recCurrentWfTaskSelector]);

  useEffect(() => {
    if (appFormLibrarySelector.length > 0) {
      const achForms = appFormLibrarySelector.filter(x => x.formType === "ACH Information");
      if (achForms.length > 0) {
        setFormsLib(achForms);
        setAchCheckCount(0);
      } else {
        setFormsLib([]);
        if (achCheckCount === 1) setAchCheckCount(2);
      }
    } else {
      setFormsLib([]);
      if (achCheckCount === 1) setAchCheckCount(2);
    }
  }, [appFormLibrarySelector]);

  useEffect(() => {
    setAppDocuments(documentsSelector);
  }, [documentsSelector]);

  const toggleReveal = (id) => {
    setRevealedDetails(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const formatMasked = (val, reveal) => {
    if (!val) return "Not Available";
    if (reveal) return val;
    if (val.length <= 4) return val;
    const maskedPart = "•".repeat(val.length - 4);
    const visiblePart = val.slice(-4);
    // Split into readable groups of 4 if it's long
    const joined = `${maskedPart}${visiblePart}`;
    return joined.replace(/(.{4})/g, "$1 ").trim();
  };

  const formatEditDate = (dateValue) => {
    if (!dateValue) return "Not Available";

    const parsedDate = moment(dateValue);
    if (!parsedDate.isValid() || parsedDate.year() <= 1900) {
      return "Not Available";
    }

    return parsedDate.format("MMM Do YYYY, h:mm a");
  };

  const handleFormShowHide = (f) => {
    setSelectedForm(f);
    setAchFormShowHide(!achFormShowHide);
    setViewBprmFormShowHide(!achFormShowHide);
  };

  const handleNoteShowHide = (type, obj) => {
    if (type === "save") {
      setSelectedForm(null);
      setNoteShowHide(false);
      if (workflowTask?.ciid > 0)
        dispatch(loadAppLibraryForms(workflowTask.ciid));
    } else {
      setSelectedForm(obj);
      setNoteShowHide(!noteShowHide);
    }
  };

  const renderVoidedCheckCard = (item) => {
    const achDocs = appDocuments.filter((x) => x.uploadType === `ach_${item.id}` && x.deleteFlag !== true);

    if (achDocs.length === 0) {
      return (
        <div
          className="ach-void-check-card ach-void-check-empty"
          onClick={() => handleUploadDocModalShowHide(`ach_${item.id}`)}
        >
          <i className="fa fa-cloud-upload ach-void-check-icon"></i>
          <span style={{ fontSize: "14px", fontWeight: "500", color: "#1e293b" }}>Upload Voided Check</span>
          <span style={{ fontSize: "14px", color: "#64748b" }}>PDF or Image format</span>
        </div>
      );
    }

    const doc = achDocs[0];
    return (
      <div className="ach-void-check-card">
        <div className="ach-void-check-info">
          <i className="fa fa-file-text-o text-primary" style={{ fontSize: "1.25rem" }}></i>
          <div className="ach-void-check-details">
            <button
              type="button"
              className="ach-void-check-name"
              title="Download Document"
              onClick={() => handleDownloadFile(doc)}
            >
              {doc.docName}
            </button>
            {doc.remarks ? (
              <span className="ach-void-check-remarks">
                {doc.remarks}
              </span>
            ) : (
              <span className="ach-void-check-remarks" style={{ fontStyle: "italic" }}>
                No notes provided
              </span>
            )}
          </div>
        </div>
        <div className="ach-void-check-actions">
          {doc.remarks && getPopover(doc.remarks)}
          <button
            type="button"
            className="ach-btn-danger-outline"
            title="Delete Document"
            onClick={() => handleDeleteAchDoc(doc.docId)}
          >
            <i className="fa fa-trash"></i>
          </button>
        </div>
      </div>
    );
  };

  const getPopover = (notes) => {
    const popover = (
      <Popover id="popover-basic">
        <Popover.Title as="h4">Notes</Popover.Title>
        <Popover.Content>{notes}</Popover.Content>
      </Popover>
    );
    return (
      <React.Fragment>
        <OverlayTrigger trigger="click" placement="top" overlay={popover}>
          <button
            type="button"
            className="ach-view-notes-btn"
          >
            <i className="fa fa-commenting-o"></i>
            Notes
          </button>
        </OverlayTrigger>
      </React.Fragment>
    );
  };

  const handleDeleteAchDoc = async (id) => {
    const result = await getConfirmAlert("Warning", "Are you sure you want to delete this Document?", "warning");
    if (result.isConfirmed) {
      dispatch(deleteDocument(id));
    }
  };

  useEffect(() => {
    if (documentDeleteStatusSelector) {
      getAlert("", "Deleted Successfully", "success");
      if (workflowTask?.ciid && (viewType !== "candidateList" || achType === "Candidate")) {
        dispatch(loadDocuments(workflowTask.ciid));
        dispatch(loadAppLibraryForms(workflowTask.ciid));
      }
    }
  }, [documentDeleteStatusSelector]);

  const handleUploadDocModalShowHide = (type) => {
    if (type === "save") {
      setDocShowHide(false);
      setUploadType("");
      refereshFormData();
    } else {
      setDocShowHide(!docShowHide);
      setUploadType(type);
    }
  };

  const addReqFormLibrary = () => {
    if (partnerCurrentWfTask?.ciid > 0 || workflowTask?.ciid > 0) {
      const achObj = {
        formId: 47,
        formName: "ACH Payment Information",
        remarks:
          "This information is captured for making Payments to your company by ACH",
        formType: "ACH Information",
      };
      const frmData = new FormData();

      if (workflowTask?.ciid && (viewType !== "candidateList" || achType === "Candidate"))
        frmData.append("workflowTask", JSON.stringify(workflowTask));
      else
        frmData.append("workflowTask", JSON.stringify(partnerCurrentWfTask));

      frmData.append("formId", achObj.formId);
      frmData.append("formName", achObj.formName);
      frmData.append("remarks", achObj.remarks);
      frmData.append("id", "");
      frmData.append("formType", achObj.formType);
      frmData.append("status", "1");
      dispatch(addFormLibrary(frmData));
    }
  };

  useEffect(() => {
    if (libraryFormAddedStatusSelector) {
      getAlert("", "Added Successfully", "success");
      if (workflowTask?.ciid > 0) {
        dispatch(loadAppLibraryForms(workflowTask.ciid));
      }
    }
  }, [libraryFormAddedStatusSelector]);

  const refereshFormData = () => {
    if (workflowTask?.ciid > 0) {
      var frmBody = new FormData();
      frmBody.append("id", achType === "Candidate" ? item.performerid : item.fuid);
      frmBody.append("name", "");
      frmBody.append("email", "");
      frmBody.append("type", "");

      if (achType === "Recruiter")
        dispatch(loadRecruiterById(frmBody));
      else if (achType === "Subcontractor")
        dispatch(loadSubcontractorById(frmBody));
      else if (achType === "Candidate") {
        frmBody.append("entity", "");
        frmBody.append("filterType", "single");
        dispatch(loadCandidateById(frmBody));
      }
    }
  };

  const handleDocumentLoad = () => {
    if (workflowTask?.ciid > 0 && (viewType !== "candidateList" || achType === "Candidate")) {
      setTimeout(() => {
        dispatch(loadAppLibraryForms(workflowTask.ciid));
      }, 1000);

      setTimeout(() => {
        dispatch(loadDocuments(workflowTask.ciid));
      }, 2000);

      setTimeout(() => {
        refereshFormData();
      }, 3000);
    }
  };

  useEffect(() => {
    if (recruiterByIdSelector.length > 0) {
      var part = recruiterByIdSelector[0];
      if (part.applications?.length > 0) {
        var partApp = part.applications[0];
        if (setSelectedApp)
          setSelectedApp(partApp);
      }
    }
  }, [recruiterByIdSelector]);

  useEffect(() => {
    if (subcontractorByIdSelector.length > 0) {
      var part = subcontractorByIdSelector[0];
      if (part.applications?.length > 0) {
        var partApp = part.applications[0];
        if (setSelectedApp)
          setSelectedApp(partApp);
      }
    }
  }, [subcontractorByIdSelector]);

  useEffect(() => {
    if (candidateByIdSelector.length > 0) {
      var part = candidateByIdSelector[0];
      if (part.applications?.length > 0) {
        var partApp = part.applications[0];
        if (setSelectedApp)
          setSelectedApp(partApp);
      }
    }
  }, [candidateByIdSelector]);

  let candidateObj = "";
  if (item) {
    candidateObj = {
      performerid: item?.id,
      applicantId: item?.id,
    };

    if (item?.subcontractor?.parentid > 0 && achType === "Subcontractor")
      candidateObj.applicantId = item?.subcontractor?.parentid;

    if (item?.recruiter?.parentid > 0 && achType === "Recruiter")
      candidateObj.applicantId = item?.recruiter?.parentid;
  }

  return (
    <div className="ach-dashboard-container">
      <style>{`
        .ach-dashboard-container {
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
          font-size: 14px;
          color: #1e293b;
          margin-bottom: 2rem;
          background: #ffffff;
          border: 1px solid rgba(226, 232, 240, 0.9);
          border-radius: 0 !important;
          overflow: hidden;
          box-shadow: 0 18px 45px rgba(15, 23, 42, 0.07);
        }
        /* pdm-header styles identical to Document.jsx */
        .pdm-header {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 18px;
          padding: 22px 24px 18px;
          background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
          border-bottom: 1px solid rgba(226, 232, 240, 0.9);
          border-radius: 0 !important;
        }
        .pdm-header-left {
          display: flex;
          align-items: flex-start;
          gap: 14px;
          min-width: 260px;
          flex: 1 1 360px;
        }
        .pdm-icon-box {
          width: 44px;
          height: 44px;
          border-radius: 0 !important;
          background: linear-gradient(135deg, #0f766e 0%, #2563eb 100%);
          border: 1px solid rgba(37, 99, 235, 0.18);
          display: flex;
          align-items: center;
          justify-content: center;
          color: #ffffff;
          font-size: 18px;
          flex-shrink: 0;
          box-shadow: 0 12px 22px rgba(15, 23, 42, 0.16);
        }
        .pdm-title-block {
          min-width: 0;
        }
        .pdm-title {
          font-size: 18px;
          font-weight: 500;
          color: #1e293b;
          margin: 0;
          line-height: 1.2;
        }
        .pdm-subtitle {
          font-size: 14px;
          font-weight: 400;
          color: #64748b;
          margin: 6px 0 0;
          max-width: 620px;
        }
        .pdm-header-actions {
          display: flex;
          align-items: center;
          gap: 8px;
          flex-wrap: wrap;
          justify-content: flex-end;
        }
        .pdm-header-meta {
          display: flex;
          align-items: center;
          gap: 7px;
          flex-wrap: wrap;
          margin-top: 10px;
        }
        .pdm-meta-pill {
          display: inline-flex;
          align-items: center;
          gap: 5px;
          padding: 3px 8px;
          height: 24px;
          min-height: 24px;
          box-sizing: border-box;
          border-radius: 0 !important;
          background: #ffffff;
          border: 1px solid #cbd5e1;
          color: #0f172a;
          font-size: 11px;
          font-weight: 600;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
          box-shadow: none !important;
        }
        .pdm-meta-pill i { font-size: 11px !important; }
        .pdm-meta-pill.meta-id i { color: #334155; }
        .pdm-meta-pill.meta-person i { color: #6d28d9; }
        .pdm-meta-pill.meta-email i { color: #0369a1; }
        .pdm-meta-pill.meta-status-active i { color: #15803d; }
        .pdm-meta-pill.meta-status-inactive i { color: #b91c1c; }
        .pdm-meta-pill.meta-status-pending i { color: #b45309; }
        .pdm-meta-pill.meta-ciid i { color: #0f766e; }
        .pdm-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          background: #ffffff;
          border: 1px solid #cbd5e1;
          padding: 0 14px;
          height: 34px;
          min-height: 34px;
          border-radius: 0 !important;
          font-family: inherit;
          font-size: 14px;
          font-weight: 500;
          color: #1e293b;
          cursor: pointer;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
          box-sizing: border-box;
          line-height: 1.25;
          text-decoration: none;
          white-space: nowrap;
          outline: none;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08);
        }
        .pdm-btn:hover {
          background: #f8fafc;
          color: #1e293b;
          border-color: #94a3b8;
          transform: translateY(-1px);
          box-shadow: 0 3px 8px rgba(15, 23, 42, 0.12);
        }
        .pdm-btn:hover i {
          transform: rotate(180deg);
        }
        .pdm-btn i {
          transition: transform 0.4s ease;
        }
        
        .ach-grid {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
          padding: 24px;
          background: #f8fafc;
        }
        .ach-card-wrapper {
          background: hsl(0, 0%, 100%);
          border: 1px solid hsl(210, 20%, 90%);
          border-radius: 0 !important;
          box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.04);
          overflow: hidden;
          transition: transform 0.25s ease, box-shadow 0.25s ease;
          display: grid;
          grid-template-columns: 320px 1fr;
        }
        @media (max-width: 992px) {
          .ach-card-wrapper {
            grid-template-columns: 1fr;
          }
        }
        .ach-card-wrapper:hover {
          transform: translateY(-2px);
          box-shadow: 0 12px 35px -8px rgba(0, 0, 0, 0.08);
        }
        
        .ach-bank-card {
          background: linear-gradient(135deg, hsl(215, 80%, 99%) 0%, hsl(215, 60%, 94%) 100%);
          padding: 1.5rem;
          color: hsl(215, 30%, 20%);
          position: relative;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          min-height: 200px;
          border-right: 1px solid hsl(215, 30%, 88%);
        }
        .ach-bank-card-bg-glow {
          display: none;
        }
        .ach-bank-card-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          z-index: 1;
        }
        .ach-bank-card-chip {
          width: 32px;
          height: 24px;
          background: linear-gradient(135deg, hsl(210, 10%, 75%) 0%, hsl(210, 10%, 55%) 100%);
          border-radius: 0 !important;
          position: relative;
          overflow: hidden;
          box-shadow: inset 0 1px 0 rgba(255,255,255,0.4);
        }
        .ach-bank-card-chip::after {
          content: "";
          position: absolute;
          top: 0; left: 0; right: 0; bottom: 0;
          border: 1px dashed rgba(0,0,0,0.15);
          margin: 2px;
        }
        .ach-bank-card-secure-badge {
          font-size: 11px;
          font-weight: 600;
          color: hsl(142, 70%, 35%);
          background: hsl(142, 70%, 93%);
          border: 1px solid hsl(142, 60%, 85%);
          padding: 2px 8px;
          border-radius: 0 !important;
          display: inline-flex;
          align-items: center;
          gap: 0.3rem;
        }
        .ach-bank-name {
          font-size: 14px;
          font-weight: 500;
          letter-spacing: 0.5px;
          color: #1e293b;
          margin-top: 1rem;
          margin-bottom: 0.5rem;
          z-index: 1;
        }
        .ach-card-fields {
          margin-top: auto;
          z-index: 1;
        }
        .ach-card-field-row {
          margin-bottom: 0.5rem;
        }
        .ach-card-field-row:last-child {
          margin-bottom: 0;
        }
        .ach-card-label {
          font-size: 12px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          color: #64748b;
          margin-bottom: 0.1rem;
        }
        .ach-card-value {
          font-family: "Courier New", Courier, monospace;
          font-size: 14px;
          font-weight: 500;
          letter-spacing: 1px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          color: #1e293b;
        }
        .ach-toggle-visibility-btn {
          background: transparent;
          border: none;
          color: #64748b;
          cursor: pointer;
          font-size: 14px;
          padding: 0.1rem 0.3rem;
          display: inline-flex;
          align-items: center;
          transition: color 0.15s ease;
        }
        .ach-toggle-visibility-btn:hover {
          color: #1e293b;
        }
        
        .ach-card-info-panel {
          padding: 1.5rem;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          gap: 1.25rem;
        }
        .ach-panel-row {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
          gap: 1.25rem;
        }
        .ach-meta-item {
          display: flex;
          flex-direction: column;
          gap: 0.25rem;
        }
        .ach-meta-label {
          font-size: 12px;
          color: #64748b;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        .ach-meta-value {
          font-size: 14px;
          font-weight: 400;
          color: #1e293b;
        }
        .ach-updated-time {
          display: flex;
          align-items: center;
          gap: 0.4rem;
          font-size: 14px;
          font-weight: 400;
          color: #1e293b;
        }
        .ach-updated-time i {
          color: #94a3b8;
        }
        
        .ach-status-badge {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          padding: 3px 8px;
          border-radius: 0 !important;
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 0.2px;
          border: 1px solid transparent;
        }
        .ach-status-locked {
          background-color: hsl(0, 75%, 97%);
          border-color: hsl(0, 70%, 93%);
          color: hsl(0, 75%, 35%);
        }
        .ach-status-allowed {
          background-color: hsl(142, 70%, 95%);
          border-color: hsl(142, 60%, 88%);
          color: hsl(142, 70%, 25%);
        }
        .ach-status-requested {
          background-color: hsl(35, 90%, 95%);
          border-color: hsl(35, 90%, 88%);
          color: hsl(35, 90%, 25%);
        }
        .ach-status-dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          display: inline-block;
        }
        .ach-status-locked .ach-status-dot {
          background-color: hsl(0, 75%, 45%);
        }
        .ach-status-allowed .ach-status-dot {
          background-color: hsl(142, 70%, 40%);
          box-shadow: 0 0 6px hsl(142, 70%, 40%);
        }
        .ach-status-requested .ach-status-dot {
          background-color: hsl(35, 90%, 45%);
          animation: ach-pulse 1.5s infinite;
        }
        
        @keyframes ach-pulse {
          0% { transform: scale(0.9); opacity: 0.6; }
          50% { transform: scale(1.2); opacity: 1; box-shadow: 0 0 6px hsl(35, 90%, 45%); }
          100% { transform: scale(0.9); opacity: 0.6; }
        }
        
        .ach-void-check-card {
          border: 1px solid hsl(210, 20%, 90%);
          border-radius: 0 !important;
          padding: 0.75rem 1rem;
          background-color: hsl(210, 20%, 98%);
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 1rem;
          transition: border-color 0.2s ease;
        }
        .ach-void-check-card:hover {
          border-color: hsl(210, 14%, 80%);
        }
        .ach-void-check-empty {
          border: 1px dashed hsl(210, 14%, 80%);
          background-color: transparent;
          cursor: pointer;
          justify-content: center;
          flex-direction: column;
          text-align: center;
          padding: 1rem;
          gap: 0.4rem;
        }
        .ach-void-check-empty:hover {
          border-color: hsl(217, 85%, 60%);
          background-color: hsl(217, 85%, 99%);
        }
        .ach-void-check-icon {
          font-size: 1.25rem;
          color: hsl(210, 14%, 50%);
        }
        .ach-void-check-empty:hover .ach-void-check-icon {
          color: hsl(217, 85%, 55%);
        }
        .ach-void-check-info {
          display: flex;
          align-items: center;
          gap: 0.6rem;
          overflow: hidden;
        }
        .ach-void-check-details {
          display: flex;
          flex-direction: column;
          overflow: hidden;
        }
        .ach-void-check-name {
          font-size: 14px;
          font-weight: 500;
          color: #1e293b;
          background: transparent;
          border: none;
          text-align: left;
          padding: 0;
          cursor: pointer;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
        .ach-void-check-name:hover {
          text-decoration: underline;
        }
        .ach-void-check-remarks {
          font-size: 14px;
          font-weight: 400;
          color: #64748b;
        }
        .ach-void-check-actions {
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }
        
        .ach-action-bar {
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-top: 1px solid hsl(210, 20%, 93%);
          padding-top: 0.85rem;
          margin-top: 0.5rem;
        }
        .ach-btn-primary {
          background-color: hsl(217, 85%, 55%);
          border: 1px solid hsl(217, 85%, 50%);
          color: white;
          padding: 7px 14px;
          border-radius: 0;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s ease;
          display: inline-flex;
          align-items: center;
          gap: 0.3rem;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08);
        }
        .ach-btn-primary:hover {
          background-color: hsl(217, 85%, 48%);
          border-color: hsl(217, 85%, 45%);
          box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
        }
        .ach-btn-secondary {
          background-color: white;
          border: 1px solid #cbd5e1;
          color: #1e293b;
          padding: 7px 14px;
          border-radius: 0;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08);
        }
        .ach-btn-secondary:hover {
          background-color: #f8fafc;
          border-color: #94a3b8;
          color: #1e293b;
        }
        .ach-btn-danger-outline {
          background-color: transparent;
          border: 1px solid hsl(0, 75%, 90%);
          color: hsl(0, 75%, 50%);
          width: 28px;
          height: 28px;
          border-radius: 0.25rem;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.2s;
        }
        .ach-btn-danger-outline:hover {
          background-color: hsl(0, 75%, 97%);
          border-color: hsl(0, 75%, 80%);
          color: hsl(0, 75%, 40%);
        }
        .ach-view-notes-btn {
          font-size: 14px;
          color: #1e293b;
          background: transparent;
          border: none;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 0.25rem;
          padding: 0;
          font-weight: 500;
        }
        .ach-view-notes-btn:hover {
          color: #1e293b;
          text-decoration: underline;
        }
        
        .ach-empty-state {
          border: 2px dashed hsl(210, 14%, 85%);
          border-radius: 0 !important;
          padding: 3rem 2rem;
          text-align: center;
          background-color: hsl(210, 20%, 99%);
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 1rem;
          max-width: 500px;
          margin: 2rem auto;
        }
        .ach-empty-icon {
          font-size: 2.5rem;
          color: hsl(210, 14%, 70%);
          background-color: hsl(210, 20%, 95%);
          width: 70px;
          height: 70px;
          border-radius: 0 !important;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .ach-empty-title {
          font-size: 14px;
          font-weight: 500;
          color: #1e293b;
          margin: 0;
        }
        .ach-empty-desc {
          font-size: 14px;
          font-weight: 400;
          color: #64748b;
          margin: 0;
          line-height: 1.4;
        }

        /* Neutral black-and-white application theme. */
        .ach-dashboard-container {
          border-color: #d1d5db !important;
          box-shadow: none !important;
        }
        .ach-dashboard-container .pdm-header {
          background: #ffffff !important;
          border-bottom-color: #d1d5db !important;
        }
        .ach-dashboard-container .pdm-icon-box {
          background: #f3f4f6 !important;
          border-color: #d1d5db !important;
          color: #525252 !important;
          box-shadow: none !important;
        }
        .ach-dashboard-container .pdm-title {
          color: #1e293b !important;
          font-weight: 500 !important;
        }
        .ach-dashboard-container .pdm-subtitle {
          color: #64748b !important;
        }
        .ach-dashboard-container *,
        .ach-dashboard-container .ach-card-wrapper,
        .ach-dashboard-container .ach-bank-card,
        .ach-dashboard-container .ach-void-check-card,
        .ach-dashboard-container .ach-empty-state,
        .ach-dashboard-container .pdm-card,
        .ach-dashboard-container .card {
          border-radius: 0 !important;
        }
        .ach-dashboard-container .pdm-meta-pill {
          background: #ffffff !important;
          border-color: #cbd5e1 !important;
          color: #0f172a !important;
          font-weight: 600 !important;
          box-shadow: none !important;
          border-radius: 0 !important;
        }
        .pdm-btn i {
          color: #1e293b !important;
          transition: transform 0.4s ease;
        }
        .ach-dashboard-container .pdm-btn i {
          color: #1e293b !important;
        }
        .ach-dashboard-container .pdm-btn,
        .ach-dashboard-container .ach-btn-primary,
        .ach-dashboard-container .ach-btn-secondary {
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          color: #1e293b !important;
          font-weight: 500 !important;
          border-radius: 0 !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
          transform: none !important;
        }
        .ach-dashboard-container .pdm-btn:hover,
        .ach-dashboard-container .ach-btn-primary:hover,
        .ach-dashboard-container .ach-btn-secondary:hover {
          background: #f8fafc !important;
          border-color: #94a3b8 !important;
          color: #1e293b !important;
          box-shadow: 0 3px 8px rgba(15, 23, 42, 0.12) !important;
          transform: none !important;
        }
        .ach-dashboard-container .pdm-btn:hover i {
          transform: none !important;
        }
        .ach-dashboard-container .ach-grid {
          background: #ffffff !important;
        }
        .ach-dashboard-container .ach-card-wrapper {
          border-color: #d1d5db !important;
          box-shadow: none !important;
        }
        .ach-dashboard-container .ach-card-wrapper:hover {
          transform: none !important;
          box-shadow: none !important;
        }
        .ach-dashboard-container .ach-bank-card {
          background: #f5f5f5 !important;
          border-right-color: #cbd5e1 !important;
          color: #1e293b !important;
        }
        .ach-dashboard-container .ach-bank-name,
        .ach-dashboard-container .ach-card-value {
          color: #1e293b !important;
          font-weight: 500 !important;
        }
        .ach-dashboard-container .ach-meta-value {
          color: #1e293b !important;
          font-weight: 400 !important;
        }
        .ach-dashboard-container .ach-card-label,
        .ach-dashboard-container .ach-meta-label,
        .ach-dashboard-container .ach-updated-time {
          color: #64748b !important;
        }
        .ach-dashboard-container .ach-updated-time {
          color: #1e293b !important;
          font-weight: 400 !important;
        }
        .ach-dashboard-container .ach-empty-icon {
          background: #f3f4f6 !important;
          border-color: #d1d5db !important;
          color: #525252 !important;
          box-shadow: none !important;
        }
        .ach-dashboard-container .ach-bank-card-chip {
          background: #d4d4d4 !important;
          box-shadow: none !important;
        }
        .ach-dashboard-container .ach-bank-card-secure-badge {
          background: #ffffff !important;
          border-color: #cbd5e1 !important;
          color: #64748b !important;
          font-weight: 600 !important;
        }
        .ach-dashboard-container .ach-bank-card-secure-badge i,
        .ach-dashboard-container .ach-toggle-visibility-btn,
        .ach-dashboard-container .ach-updated-time i {
          color: #94a3b8 !important;
        }
        .ach-dashboard-container .ach-meta-label {
          font-weight: 600 !important;
        }
        .ach-dashboard-container .ach-meta-value {
          font-weight: 400 !important;
        }
        .ach-dashboard-container .ach-void-check-card {
          background: #f8fafc !important;
          border-color: #e5e7eb !important;
          box-shadow: none !important;
        }
        .ach-dashboard-container .ach-void-check-card:hover,
        .ach-dashboard-container .ach-void-check-empty:hover {
          background: #f5f5f5 !important;
          border-color: #d1d5db !important;
          box-shadow: none !important;
        }
        .ach-dashboard-container .ach-void-check-empty {
          background: #ffffff !important;
          border-color: #d1d5db !important;
        }
        .ach-dashboard-container .ach-void-check-icon,
        .ach-dashboard-container .ach-void-check-empty:hover .ach-void-check-icon,
        .ach-dashboard-container .ach-void-check-info > i {
          color: #94a3b8 !important;
        }
        .ach-dashboard-container .ach-void-check-name,
        .ach-dashboard-container .ach-view-notes-btn,
        .ach-dashboard-container .ach-view-notes-btn:hover {
          color: #1e293b !important;
          font-weight: 500 !important;
        }
        .ach-dashboard-container .ach-void-check-remarks {
          color: #64748b !important;
          font-weight: 400 !important;
        }
      `}</style>

      {hideHeader !== true && (
        <div className="pdm-header">
          <div className="pdm-header-left">
            <div className="pdm-icon-box">
              <i className="fa fa-university" />
            </div>
            <div className="pdm-title-block">
              <p className="pdm-title">ACH Payment Information</p>
              <div className="pdm-header-meta">
                <span className="pdm-meta-pill meta-id">
                  <i className="fa fa-id-badge" /> ID: {item?.fuid || "New"}
                </span>
                {item?.label && (
                  <span className="pdm-meta-pill meta-person">
                    <i className="fa fa-user" /> {item.label}
                  </span>
                )}
                {item?.email && (
                  <span className="pdm-meta-pill meta-email">
                    <i className="fa fa-envelope-o" /> {item.email}
                  </span>
                )}
                <span className={`pdm-meta-pill ${item?.contact1?.isActive === true ? 'meta-status-active' : item?.contact1?.isActive === false ? 'meta-status-inactive' : 'meta-status-pending'}`}>
                  <i className="fa fa-info-circle" /> Status: {
                    item
                      ? (item.contact1?.isActive === true
                        ? "Active"
                        : item.contact1?.isActive === false
                          ? "Inactive"
                          : "Pending Activation")
                      : "New Partner"
                  }
                </span>
                {(((viewType === "candidateList" && achType !== "Candidate") ? partnerCurrentWfTask : workflowTask)?.ciid) && (
                  <span className="pdm-meta-pill meta-ciid">
                    <i className="fa fa-hashtag" /> CIID {((viewType === "candidateList" && achType !== "Candidate") ? partnerCurrentWfTask : workflowTask).ciid}
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className="pdm-header-actions">
            {typeof onBack === "function" && (
              <button className="pdm-btn" onClick={onBack}>
                <i className="fa fa-arrow-left" style={{ marginRight: "4px" }}></i> Back
              </button>
            )}
            <button className="pdm-btn" onClick={handleDocumentLoad}>
              <i className="fa fa-refresh"></i> Refresh
            </button>
          </div>
        </div>
      )}

      <div className="ach-grid">
        {isLoading && (
          <div className="ach-empty-state">
            <div className="ach-empty-icon">
              <i className="fa fa-spinner fa-spin"></i>
            </div>
            <h4 className="ach-empty-title">Loading ACH information…</h4>
          </div>
        )}

        {formsLib.map((item, key) => {
          const bankName = getFieldData(
            (viewType === "candidateList" && achType !== "Candidate") ? partnerAppData : app?.applicationData,
            "achinfo",
            "Bank_Name"
          );
          const routingNumber = getFieldData(
            (viewType === "candidateList" && achType !== "Candidate") ? partnerAppData : app?.applicationData,
            "achinfo",
            "Routing"
          );
          const accountNumber = getFieldData(
            (viewType === "candidateList" && achType !== "Candidate") ? partnerAppData : app?.applicationData,
            "achinfo",
            "Account_No"
          );
          const reveal = !!revealedDetails[item.id];
          const editDate = formatEditDate(
            item.allowEdit === 2 ? item.editReqDateTime : item.allowEditDateTime,
          );

          return (
            <div className="ach-card-wrapper" key={item.id || key}>
              <div className="ach-bank-card">
                <div className="ach-bank-card-bg-glow"></div>
                <div className="ach-bank-card-header">
                  <div className="ach-bank-card-chip"></div>
                  <div className="ach-bank-card-secure-badge">
                    <i className="fa fa-shield" style={{ marginRight: "3px" }}></i> Direct Deposit
                  </div>
                </div>

                <div className="ach-bank-name">
                  {bankName || "Unknown Bank"}
                </div>

                <div className="ach-card-fields">
                  <div className="ach-card-field-row">
                    <div className="ach-card-label">Routing Number</div>
                    <div className="ach-card-value">
                      <span>{formatMasked(routingNumber, reveal)}</span>
                      <button
                        type="button"
                        className="ach-toggle-visibility-btn"
                        onClick={() => toggleReveal(item.id)}
                        title={reveal ? "Hide Details" : "Show Details"}
                      >
                        <i className={`fa ${reveal ? "fa-eye-slash" : "fa-eye"}`}></i>
                      </button>
                    </div>
                  </div>

                  <div className="ach-card-field-row">
                    <div className="ach-card-label">Account Number</div>
                    <div className="ach-card-value">
                      <span>{formatMasked(accountNumber, reveal)}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="ach-card-info-panel">
                <div className="ach-panel-row">
                  <div className="ach-meta-item">
                    <div className="ach-meta-label">Last Updated</div>
                    <div className="ach-meta-value">
                      {item.lastUpdate ? (
                        <div className="ach-updated-time">
                          <i className="fa fa-calendar-o"></i>
                          <div>
                            <Moment format="MMM Do YYYY">{item.lastUpdate}</Moment>
                            <span style={{ margin: "0 4px", color: "#94a3b8" }}>•</span>
                            <Moment format="h:mm a">{item.lastUpdate}</Moment>
                          </div>
                        </div>
                      ) : (
                        <span style={{ color: "#64748b", fontSize: "14px", fontWeight: 400 }}>Never</span>
                      )}
                    </div>
                  </div>

                  <div className="ach-meta-item">
                    <div className="ach-meta-label">Edit Permissions</div>
                    <div className="ach-meta-value">
                      {item.allowEdit === 0 && (
                        <span className="ach-status-badge ach-status-locked">
                          <span className="ach-status-dot"></span>
                          <i className="fa fa-lock" style={{ marginRight: "3px" }}></i>
                          Edit Locked
                        </span>
                      )}
                      {item.allowEdit === 2 && (
                        <span className="ach-status-badge ach-status-requested">
                          <span className="ach-status-dot"></span>
                          Request Received
                        </span>
                      )}
                      {item.allowEdit === 1 && (
                        <span className="ach-status-badge ach-status-allowed">
                          <span className="ach-status-dot"></span>
                          Edit Allowed
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                {(item.allowEdit === 2 || item.allowEdit === 1) && (
                  <div style={{ fontSize: "14px", backgroundColor: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: "0", padding: "7px 14px" }}>
                    <div style={{ color: "#64748b", fontWeight: 600, marginBottom: "0.15rem", fontSize: "12px", textTransform: "uppercase" }}>
                      {item.allowEdit === 2 ? "Requested" : "Approved"} on:{" "}
                      <span style={{ fontWeight: 400, color: "#1e293b", fontSize: "14px", textTransform: "none" }}>
                        {editDate}
                      </span>
                    </div>
                    {item.editRemarks && (
                      <div style={{ color: "#64748b", fontStyle: "italic", fontWeight: 400 }}>
                        "{item.editRemarks}"
                      </div>
                    )}
                  </div>
                )}

                <div className="ach-meta-item">
                  <div className="ach-meta-label" style={{ marginBottom: "0.4rem" }}>Voided Check Document</div>
                  {renderVoidedCheckCard(item)}
                </div>

                <div className="ach-action-bar">
                  <button
                    className="ach-btn-primary"
                    onClick={() => handleFormShowHide(item)}
                  >
                    <i className="fa fa-wpforms" style={{ marginRight: "4px" }}></i>
                    View/Edit Form
                  </button>

                  {(item.allowEdit === 0 || item.allowEdit === 2) && (
                    <button
                      className="ach-btn-secondary"
                      onClick={() => handleNoteShowHide("", item)}
                    >
                      <i className="fa fa-key" style={{ marginRight: "4px" }}></i>
                      Allow Edit
                    </button>
                  )}
                </div>
              </div>
            </div>
          );
        })}

        {!isLoading && formsLib.length === 0 && achCheckCount === 2 && (
          <div className="ach-empty-state">
            <div className="ach-empty-icon">
              <i className="fa fa-shield"></i>
            </div>
            <h4 className="ach-empty-title">Secure ACH Information Required</h4>
            <p className="ach-empty-desc">
              No ACH Payment Information form has been registered for this account yet. Registering ACH allows automated, secure direct deposit payments.
            </p>
            <button
              className="ach-btn-primary"
              style={{ marginTop: "0.5rem" }}
              onClick={addReqFormLibrary}
            >
              <i className="fa fa-plus-circle" style={{ marginRight: "4px" }}></i>
              Initiate ACH Setup
            </button>
          </div>
        )}
      </div>

      {achFormShowHide && (
        <ViewFormModal
          viewFormShowHide={achFormShowHide}
          handleViewForm={handleFormShowHide}
          workflowTask={(viewType === "candidateList" && achType !== "Candidate") ? partnerCurrentWfTask : workflowTask}
          selectedForm={selectedForm}
          refereshFormData={refereshFormData}
          formName="ACH Information"
        />
      )}

      {noteShowHide && (
        <AddEditNotes
          noteShowHide={noteShowHide}
          handleNoteShowHide={handleNoteShowHide}
          notesType="formEditReq"
          candidateObj={candidateObj}
          selectedObj={selectedForm}
        />
      )}

      {docShowHide && (
        <CandidateReqDoc
          docShowHide={docShowHide}
          handleDocShowHide={handleUploadDocModalShowHide}
          workItem={(viewType === "candidateList" && achType !== "Candidate") ? partnerCurrentWfTask : workflowTask}
          sendType={"upload"}
          uploadType={uploadType}
          viewType={"candidateList"}
          applicantObj={candidateObj}
        />
      )}
    </div>
  );
};

export default AchInformation;
